import React, { useState } from "react";
import { useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import '../styles/Login.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { isValidPhoneNumber } from "libphonenumber-js";
import axios from 'axios';
const Registr = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setUser, setIsAuthenticated, isAuthenticated } = useAuth()



  const [phone, setPhone] = useState('');

  const [isPasswordClose, setIsPasswordClose] = useState(true)

  const passwordRef = useRef(null)

  const [currencySelector, setCurrencySelector] = useState(false)
  const [currencyState, setCurrencyState] = useState('uzs')

  const handlePhoneChange = (value) => {
    setPhone(value);
    console.log('Selected phone:', value);
    if(!isValid) {
      setIsValid(true)
    }
  };
  


  const [defaultCountry, setDefaultCountry] = useState('ru'); // Страна по умолчанию (запасной вариант)
  const [isValid, setIsValid] = useState(true);
  useEffect(() => {
    // Получение страны по IP
    const fetchCountryCode = async () => {
      try {
        const response = await axios.get('https://ipapi.co/json/'); // Используется IP-API
        const countryCode = response.data.country_code.toLowerCase(); // Получаем код страны в нижнем регистре
        setDefaultCountry(countryCode);
      } catch (error) {
        console.error('Ошибка при определении страны:', error);
      }
    };

    fetchCountryCode();
  }, []);



  const registrFetch = async (e) => {
    e.preventDefault()
    if(!isValid) {
      return
    }
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/registration`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password, phoneNumber: phone, mainWallet: currencyState, }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("token", data.token); // Сохраняем токен в локальном хранилище
        setUser(data.user);
        setIsAuthenticated(true)
        navigate('/games/aviator')
      } else {
        const errorData = await response.json();
        console.log(Array.isArray(errorData))
        console.log(errorData)
        if(Array.isArray(errorData)) {
          if(errorData[0].msg) {
            setError(errorData[0].msg)
          }
        } else {
          setError(errorData.message || "Ошибка авторизации");
        }
        
      }
    } catch (error) {
      
    }
  }



  useEffect(() => {
    if(passwordRef) {
      isPasswordClose ? passwordRef.current.type = 'password' : passwordRef.current.type = 'text'
    }
  }, [isPasswordClose])

  useEffect(() => {
    if (isAuthenticated === true) {
      navigate('/games/aviator')
    }
  }, [isAuthenticated])

  return (
    <div className={'login-wrapper'}>
      <div className={'login-container-wrap'}>
      <h1>Registration</h1>
      
      <div className={'auth-check-wrap'}>
        <div className={`fast-register`}>
            <p>Quick Registration</p>
        </div>
      </div>



      {error && <p style={{ color: "red" }}>{error}</p>}
      <form className={'login-form-container'} onSubmit={registrFetch}>
      <div className={'registr-currency-wrap'}>
        <div className={'registr-currency-container'}>
        {/* {currencyState === 'uzs' ? <p>UZS <span>Uzbek so'm (UZS)</span></p> : ""} */}
        {/* {currencyState === 'usd' ? <p>USD <span>US Dollar (USD)</span></p> : ""}
        {currencyState === 'rub' ? <p>RUB <span>Russian Ruble (RUB)</span></p> : ""} */}
        <p>UZS <span>Uzbek so'm (UZS)</span></p>
        {/* <img src="/assets/img/main/arrow.svg" alt="" /> */}
        </div>
        {currencySelector && <div className={'currency-selector-wrap'}>
            <div className={'currency-selector-item'} onClick={() => {
              setCurrencyState('uzs')
              setCurrencySelector(false)
            }}>
              <p>UZS <span>Uzbek so'm (UZS)</span></p>
              {currencyState === 'uzs' ? <img src="/assets/img/main/accept.png" alt="" /> : ""}
            </div>
            <div className={'currency-selector-item'} onClick={() => {
              setCurrencyState('usd')
              setCurrencySelector(false)
            }}>
              <p>USD <span>US Dollar (USD)</span></p>
              {currencyState === 'usd' ? <img src="/assets/img/main/accept.png" alt="" /> : ""}
            </div>
            <div className={'currency-selector-item'} onClick={() => {
              setCurrencyState('rub')
              setCurrencySelector(false)
            }}>
              <p>RUB <span>Russian Ruble (RUB)</span></p>
              {currencyState === 'rub' ? <img src="/assets/img/main/accept.png" alt="" /> : ""}
            </div>
          </div>}
        </div>
      <div className={'phone-number-input-wrapper'}>
            <PhoneInput
            id="phone-input"
        country={defaultCountry}
        value={phone}
        onChange={handlePhoneChange}
        enableSearch={true} // Включение поиска
        inputStyle={{
          width: '100%',
          height: '40px',
          borderColor: isValid ? 'initial' : 'red', // Цвет бордера при ошибке
        }}
        inputProps={{
          onFocus: () => {
            console.log("Input was focused!");
            if(!isValid) {
              setIsValid(true)
            }
          },
        }}
        
      />
      {!isValid && <div style={{ color: 'red', fontSize: '12px' }}>Некорректный номер телефона</div>}
    </div>
        <div className={'login-email-wrapper'}>
          <img className={'login-email-wrapper-img'} src="/assets/img/main/Mail.svg" alt="" />
        <input
        className={'login-email-input'}
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
            if(error !== "") {
              setError("")
            }
          }}
          required
        />
        </div>
        <div className={'login-password-wrapper'}>
          <img src="/assets/img/main/password.svg" alt="" />
          <div className={'login-password-wrapper-img'}></div>
        <input

        className={'login-password-input'}
          ref={passwordRef}
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value)
            if(error !== "") {
              setError("")
            }
          }}
          required
        />
        <img className={'login-close-eye'} src={isPasswordClose ? "/assets/img/main/eye.png" : "/assets/img/main/view.png"} alt="" onClick={() => setIsPasswordClose((prev) => !prev)} />
        </div>
        <button className={'login-form-button'} type="submit" onClick={() => {
          setIsValid(isValidPhoneNumber(`+${phone}`))
        }}>Register</button>
      </form>
      <div className={'login-wrapper-footer'}>Already have an account? <span className={'font-bold'} onClick={() => {
        navigate('/login')
      }}>Login</span></div>
      </div>
    </div>
  );
};

export default Registr;